import { render, staticRenderFns } from "./PrizeDescription.vue?vue&type=template&id=46125f73&"
import script from "./PrizeDescription.vue?vue&type=script&lang=js&"
export * from "./PrizeDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports